<template>
  <div class="upgrade-package-panel" v-if="userData && userData.PackageUpgradeUrl">
      {{ $t("UpgradePackagePanel.UpgradeMessage") }}
      <a class="btn-upgrade btn btn-outline-danger btn-sm" :href="userData.PackageUpgradeUrl" target="_blank">
          {{ $t("UpgradePackagePanel.UpgradeButton") }}
      </a>    
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { UserData } from "@/models/UserData";
import { Getter } from "vuex-class";

const namespace = "mainModule";

@Component({
  components: {},
})
export default class UpgradePackagePanel extends Vue {

  //#region Vuex getters and actions

  @Getter("userData", { namespace }) userData!: UserData;

  //#endregion Vuex getters and actions
}
</script>

<style lang="scss" scoped>
.upgrade-package-panel {
  background-color: #f2dede;
  border: 1px solid #ebcccc;
  color: #a94442;
  margin-bottom: 1rem;
  padding: 0.75rem 1.25rem;

  .btn {
    display: inline-block;
    font-weight: normal;
    line-height: 1.25;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    transition: all 0.2s ease-in-out;

    &.btn-sm {
      font-size: 0.875rem;
      padding: 0.25rem 0.5rem;
    }

    &.btn-outline-danger {
      color: #f86c6b;
      background-image: none;
      background-color: transparent;
      border-color: #f86c6b;
    }

    &.btn-upgrade {
      background: #fff;
      margin: 0 1rem;
    }
  }
}
</style>
